import { IAuditEntity } from "@ucl/library";
import {
  IBoltTaskTemplate,
  BoltTaskTypePriorities,
  SLAUnits,
  TaskExecutionTypeFieldSchema,
} from "./BoltTaskTemplate";

export enum BoltTaskStatuses {
  New = 1,
  InProgress = 2,
  OnHold = 3,
  Completed = 4,
  Reopened = 5,
  Withdrawn = 6,
  Skipped = 7,
}

export interface INewBoltTask {
  taskStatus: BoltTaskStatuses;
  taskTemplateId: string;
  taskTemplateName?: string;
  taskTemplateDescription?: string;
  stepName: string;
  assigneeId?: string; // Using string for UUID
  assigneeName?: string;
  isRush?: boolean;
  taskTemplateSOP: string;
  taskTemplateSOP_AsList: string[];
  detail: string;
  taskNumber?: string;
  completedBy?: string;
  completedDate?: Date;
  timezoneId: string;
  sla?: number;
  slaUnit?: SLAUnits;
  dueDate?: Date;
  startedAt?: string;
  workflow: string;
  taskExecutionType: string;
  taskExecutionTypeName: string;
  taskExecutionTypeFields?: TaskExecutionTypeFieldSchema;
  taskTemplate?: IBoltTaskTemplate;
  taskStatus_AsString?: string;
  taskPriority?: BoltTaskTypePriorities;
  taskPriority_AsString?: string;
  parentEntityId?: string;
  parentEntityType?: string;
  entityId?: string;
  entityType?: string;
  taskRuleId?: string;
}

export interface IBoltTask extends INewBoltTask, IAuditEntity {
  taskNumber: string;
  taskNumber_AsString: string;
}
